"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponents = exports.SelectBase = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _layers = require("../../constants/layers");
var _LayerContext = require("../../util/layerContext/LayerContext");
var _ClearIndicator = require("./components/ClearIndicator");
var _Control = require("./components/Control");
var _DropdownIndicator = require("./components/DropdownIndicator");
var _IndicatorSeparator = require("./components/IndicatorSeparator");
var _IndicatorsContainer = require("./components/IndicatorsContainer");
var _Input = require("./components/Input");
var _LoadingIndicator = require("./components/LoadingIndicator");
var _Menu = require("./components/Menu");
var _MenuList = require("./components/MenuList");
var _MenuPortal = require("./components/MenuPortal");
var _MultiValue = require("./components/MultiValue");
var _Option = require("./components/Option");
var _Placeholder = require("./components/Placeholder");
var _StaticPropContext = require("./components/StaticPropContext");
var _ValidationContext = require("./components/ValidationContext");
const warnOnDeprecatedSuccessValidationState = (0, _lodestarUtils.warnOnce)(`validationState="success" is deprecated. It will be removed in the future. If you have a need for it, please contact the UI Engineering team.`);
const getComponents = function () {
  let components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const defaultComponents = {
    ClearIndicator: _ClearIndicator.ClearIndicator,
    Control: _Control.Control,
    DropdownIndicator: _DropdownIndicator.DropdownIndicator,
    IndicatorSeparator: _IndicatorSeparator.IndicatorSeparator,
    IndicatorsContainer: _IndicatorsContainer.IndicatorsContainer,
    Input: _Input.Input,
    LoadingIndicator: _LoadingIndicator.LoadingIndicator,
    Menu: _Menu.Menu,
    MenuList: _MenuList.MenuList,
    MenuPortal: _MenuPortal.MenuPortal,
    MultiValue: _MultiValue.MultiValue,
    Option: _Option.Option,
    Placeholder: _Placeholder.Placeholder
  };
  return {
    ...defaultComponents,
    ...components
  };
};
exports.getComponents = getComponents;
const SelectBase = props => {
  const {
    innerRef
  } = props;
  const onSelectRef = (0, _react.useCallback)(ref => {
    const subsetOfReactSelect = {
      blur: () => ref?.blur(),
      focus: () => ref?.focus()
    };
    if (innerRef && typeof innerRef === "object") {
      innerRef.current = subsetOfReactSelect;
    }
    if (typeof innerRef === "function") {
      innerRef(subsetOfReactSelect);
    }
  }, [innerRef]);
  const {
    validationState = "default",
    clientId,
    components,
    options,
    onCreateOption,
    getNewOptionData,
    value,
    filterOption,
    ...restProps
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (validationState === "success") {
      warnOnDeprecatedSuccessValidationState();
    }
  }
  const commonProps = {
    ...restProps,
    ref: onSelectRef,
    onCreateOption,
    options: options,
    components: getComponents(components),
    spacing: "default",
    escapeClearsValue: false,
    tabSelectsValue: false,
    closeMenuOnScroll: true,
    // This helps the Control not re-render as much, but the MenuList is still bad.
    // See https://blog.johnnyreilly.com/2019/04/react-select-with-less-typing-lag.html
    filterOption: filterOption || (0, _reactSelect.createFilter)({
      ignoreAccents: false
    }),
    // A null value is required for react-select to be cleared to show the placeholder
    value: value === undefined ? null : value,
    // Give the select menu the correct z-index.
    // Currently this is the most reasonable way to do it with react-select, as the MenuPortal component
    // doesn't play nice with styled components.
    // https://github.com/JedWatson/react-select/issues/2909
    styles: {
      menuPortal: function () {
        let css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return {
          ...css,
          // See the LayerContext below as well.
          zIndex: _layers.layers.context
        };
      }
    }
  };

  // This is a workaround for a react-select creatable bug. Please be sure that the returned
  // object has an attribute (in this case, `__Fix3988`) with a function value.
  // https://github.com/JedWatson/react-select/issues/3988
  const defaultGetNewOptionData = (inputValue, optionLabel) => ({
    __Fix3988: () => false,
    ...(getNewOptionData ? getNewOptionData(inputValue, optionLabel) : {
      label: optionLabel,
      value: inputValue
    })
  });
  const memoizedStaticProps = (0, _react.useMemo)(() => ({
    clientId
  }), [clientId]);
  return (
    /*#__PURE__*/
    // StaticPropContext should be the outermost context since we don't expect it to change often.
    _react.default.createElement(_StaticPropContext.StaticPropContext.Provider, {
      value: memoizedStaticProps
    }, /*#__PURE__*/_react.default.createElement(_ValidationContext.ValidationContext.Provider, {
      value: validationState
    }, /*#__PURE__*/_react.default.createElement(_LayerContext.LayerContextProvider, {
      defaultLayer: "__unstable-select-v1-menu"
    }, onCreateOption !== undefined ? /*#__PURE__*/_react.default.createElement(_creatable.default, (0, _extends2.default)({}, commonProps, {
      getNewOptionData: defaultGetNewOptionData
    })) : /*#__PURE__*/_react.default.createElement(_reactSelect.default, commonProps))))
  );
};
exports.SelectBase = SelectBase;
//# sourceMappingURL=SelectBase.js.map